import styled, { css } from 'styled-components';
import { ifProp, prop } from 'styled-tools';

export const RectangleGraphic = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  margin: 20px 6px 20px 0;
`;

export const RectangleGraphicItem = styled.section`
  max-width: 35px;
  width: 100%;
  max-height: 140px;
  height: ${prop('size')}px;
  background: #1bb15a;
  font-weight: 500;
  font-size: 9px;
  line-height: 140%;
  display: flex;
  align-items: flex-start;
  color: #ffffff;

  span {
    display: block;
    margin: 0 auto;
  }

  @media (max-width: 1570px) {
    max-width: 40px;
  }
`;

export const RectangleGraphicText = styled.div`
  font-weight: normal;
  font-size: 12px;
  line-height: 170%;
  text-align: center;
  text-decoration-line: underline;
  color: #2d9cdb;
`;

export const RectangleGraphicWrapper = styled.section`
  display: flex;
  align-items: flex-end;

  ${ifProp(
    'red',
    css`
      transform: rotateX(180deg) translateY(-70%);
      @media (max-width: 1100px) {
        transform: rotateX(180deg) translateY(31px);
        margin-left: 0 !important;
      }

      ${RectangleGraphicItem} {
        background: #f6543e;
        span {
          transform: rotateX(-180deg);
        }
      }

      ${RectangleGraphicText} {
        transform: rotateX(-180deg);
      }
    `
  )}

  ${ifProp(
    'parent',
    css`
      @media (max-width: 1100px) {
        flex-direction: column;
        margin: 0 auto;
        align-items: center;
      }
    `
  )}

  ${RectangleGraphic} + ${RectangleGraphic} {
    margin-left: 10px;

    @media (max-width: 1570px) {
      margin-left: -2px;
    }
  }
`;

export const GainersAndLosersWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: #fff;
  max-width: 750px;
  height: 450px;
  padding: 33px 33px;
  width: 50%;
  box-shadow: 0px 20px 40px 0px #19192e0d;

  @media (max-width: 1100px) {
    width: 100%;
    min-height: 450px;
    height: auto;
    padding: 33px 10px;
  }

  @media (max-width: 600px) {
    background: transparent;
    box-shadow: none;
  }

  ${RectangleGraphicWrapper} + ${RectangleGraphicWrapper} {
    margin-left: 23px;
  }
`;

export const GainersAndLosersBottemText = styled.p`
  font-weight: normal;
  font-size: 12px;
  line-height: 170%;
  letter-spacing: 0.04em;
  color: #3f4047;
  padding-top: 10px;
  border-top: 1px solid #c4c4c4;
  max-width: 552px;
  width: 100%;
`;

export const ChartTitle = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 240px;
  height: 40px;
  padding: 12px 0;
  background: #e6f3fc;
  border-radius: 2px 0px 0px 0px;
  font-weight: bold;
  font-size: 12px;
  line-height: 150%;
  text-align: center;
  letter-spacing: 0.02em;
  color: #2d9cdb;

  @media (max-width: 600px) {
    ${ifProp(
      'onlyDesktop',
      css`
        display: none;
      `
    )}
    left: 50%;
    transform: translateX(-50%);
    width: 163px;
    height: 38px;
    font-weight: bold;
    font-size: 12px;
    line-height: 150%;
    text-align: center;
    letter-spacing: 0.02em;
    color: #0384e0;
    margin: 0 auto;
    border-radius: 100px;
  }
`;

export const ChartTitleText = styled.span`
  position: relative;
`;

export const ChartTitleMoreInfo = styled.div`
  position: absolute;
  right: -18px;
  top: -4px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #2d9cdb;
  color: #fff;
  font-weight: bold;
  font-size: 7px;

  @media (max-width: 600px) {
    right: -33px;
    top: -25px;
  }
`;
